import React from 'react';
import axios from 'axios';
import { Auth } from './screens';
import Home from './navigation/Home';
import AppTheme from './shared-theme/AppTheme';
import { Box, CircularProgress } from '@mui/material';

import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { getApp, getApps, initializeApp } from 'firebase/app';

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();
export const auth = getAuth(app);

const api = axios.create({
    baseURL: 'https://app.highdunesuae.com', 
});

api.interceptors.request.use(async(config) => {
    const user = auth.currentUser;
    if(user){
        const token = await user.getIdToken();
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => Promise.reject(error));

export const jaxa = api;

export default function App(props) {

    const [user, setUser] = React.useState(null);

    React.useEffect(() => {
        onAuthStateChanged(auth, (isUser) => {
            if(isUser) setUser(true);
            else setUser(false);
        });
    }, []);

    const loader = React.useMemo(() => (
        <AppTheme {...props}>
            <Box sx={{ width: '100%', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <CircularProgress/>
            </Box>
        </AppTheme>
    ), [props]);

    if(user === null) return loader;

    return user ? <Home/> : <Auth/>;

};